<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="关键字搜索(名称)"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.userId"
        placeholder="用户ID"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="账号状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in WITHDRAW_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <div style="margin: 5px 0">会员数量:{{ total }}</div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      

      <el-table-column
        label="用户ID"
        align="center"
        prop="userId"
      ></el-table-column>

      <el-table-column
        align="center"
        prop="orderNo"
        label="提现订单号"
        width="120px"
      ></el-table-column>
      <el-table-column
        label="银行名称"
        align="center"
        prop="bankName"
        width="120px"
      ></el-table-column>

      <el-table-column
        label="银行账号"
        align="center"
        prop="bankAccount"
        width="120px"
      ></el-table-column>

      <el-table-column
        label="支行名称"
        align="center"
        prop="branchName"
        width="120px"
      ></el-table-column>

      <el-table-column
        label="开户名"
        align="center"
        prop="accountName"
        width="120px"
      ></el-table-column>
      <!-- <el-table-column
        label="提现账户ID"
        align="center"
        prop="accountId"
      ></el-table-column> -->

      <el-table-column
        label="提现金额"
        align="center"
        prop="amount"
      ></el-table-column>

      <el-table-column
        label="驳回原因"
        align="center"
        prop="remark"
      ></el-table-column>

      <el-table-column align="center" prop="status" label="状态" width="95">
        <template slot-scope="scope">
          <span>{{ getValue(WITHDRAW_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="凭证" align="center" prop="imgUrl" width="120">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.imgUrl"
            style="width: 100px; height: 100px"
            :src="scope.row.imgUrl"
            fit="cover"
            :preview-src-list="[scope.row.imgUrl]"
          ></el-image>
          <UploadList
            v-else
            class="upload-list"
            :typeProps="UPLOAD_IMG_TYPE.COMMON"
            paramsType="attData"
            @valueFunc="(att, val) => getAttDataValueFunc(att, val, scope.row)"
            :maxCount="1"
          />
        </template>
      </el-table-column>

      
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="220"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="withdrawalRequest(scope.row)"
            class="comm_but_warp"
            >提现受理</el-button
          >
          <el-button
            v-if="scope.row.status == 0"
            style="background:red;borderColor:red"
            type="primary"
            size="mini"
            @click="onBo(scope.row)"
            class="comm_but_warp"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog :visible.sync="isBo" :append-to-body='true'>
      <div class="dialog-view" v-if="curRow">
        <span style="font-size:30px;" class="dia-pos">提现驳回</span>
        <div class="dialog-content">
          <div class="dialog-left">
            提现用户ID:
          </div>
          <div class="dialog-right">
            {{curRow.userId}}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            提现订单号:
          </div>
          <div class="dialog-right">
            {{curRow.orderNo}}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            驳回原因:
          </div>
          <div class="dialog-right">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="remark">
            </el-input>
          </div>
        </div>
      </div>
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onBoHui">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAgentConfigList,
  uploadFileWithdraw,
  checkWithdraw,
  reviewAgentWithdraw
} from "@/api/agent";
import { formatApiDate } from "@/utils/utils";
import UploadList from "@/views/components/uploadList.vue";
import { getValue, UPLOAD_IMG_TYPE } from "@/utils/enumUtile";

const MEMBER_CER_STATUS = [
  { key: 0, value: "提现待审核" },
  { key: 1, value: "提现成功" },
  { key: 2, value: "提现失败" },
  { key: 3, value: "取消提现" },
];
export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      isBo:false,
      listQuery: {
        page: 1,
        pageSize: 10,
        name: null,
        userId: null,
        status: null,
      },
      WITHDRAW_STATUS: MEMBER_CER_STATUS,
      curRow:null,
      remark:''
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getValue,
    onBo(row){
      this.curRow = row;
      this.isBo = true;
    },
    onBoHui(){
      let params = {
        id:this.curRow.id,
        status:3,
        remark:this.remark
      }
      reviewAgentWithdraw(params).then(res=>{
        
        this.$message.success("驳回成功");
        this.getList();
        this.onClose();
      })
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      getAgentConfigList(this.listQuery).then((res) => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    onClose(){
      this.remark = '';
      this.curRow = null;
      this.isBo = false;
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 上传图片
    getAttDataValueFunc(type, res, row) {
      console.log("上传图片getAttDataValueFunc", type, res);
      if (type === "attData") {
        uploadFileWithdraw({ imgUrl: res[0].url, id: row.id }).then((res) => {
          this.$message.success("上传成功");
          this.getList();
        });
      }
    },
    withdrawalRequest(row) {
      checkWithdraw({ id: row.id, status: 1 }).then((res) => {
        this.$message.success("提现申请成功");
         this.getList();
      });
    },
  },
  computed: {
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    formatApiDate() {
      return formatApiDate;
    },
  },
  components: { UploadList },
};
</script>

<style lang="scss" scoped>
.dialog-view{
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom:20px;
  margin-top:30px;
  position: relative;
  .dialog-content{
    width:100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .dialog-left{
      width:200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
    .dialog-right{
      flex:1;
      margin-left:20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .dia-pos{
    position: absolute;
    top:-70px;
  }
  
}
.upload-list {
  ::v-deep .upload_list_warp {
    .el-upload {
      width: 80px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  ::v-deep .el-upload__tip {
    display: none;
  }
}
</style>
